/**
 * Okendo Star Rating Redirect
 *
 * This script waits for the Okendo star rating widget to appear on the page,
 * then overrides its default click behavior to redirect to the testimonials page.
 */
function setupOkendoRedirect() {
  // This is the specific container for the star rating widget.
  const starRatingWidget = document.querySelector('[data-oke-star-rating]');

  // If the widget exists on the page...
  if (starRatingWidget) {
    // Change the cursor to a pointer to show it's clickable.
    starRatingWidget.style.cursor = 'pointer';

    // Add our own click listener.
    // The 'true' at the end makes our listener run before Okendo's default one.
    starRatingWidget.addEventListener('click', function(event) {
      // Stop the original Okendo script from running.
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      // Redirect the user to the testimonials page.
      window.location.href = '/pages/testimonials';

    }, true);

    // Once we've set up the redirect, we don't need to check anymore.
    // So, we'll stop the observer that's looking for the element.
    if (observer) {
      observer.disconnect();
    }
  }
}

// Shopify 2.0 themes and apps load dynamically.
// We need to "watch" the page for when the Okendo widget is added.
// A MutationObserver is the most reliable way to do this.
const observer = new MutationObserver((mutations) => {
  // Check if the star rating widget is now on the page.
  if (document.querySelector('[data-oke-star-rating]')) {
    setupOkendoRedirect();
  }
});

// Start watching for changes in the entire page structure.
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Also run the setup function when the page first loads,
// just in case the widget is already there.
document.addEventListener('DOMContentLoaded', setupOkendoRedirect);